import React from "react";
import ImageWithTag from "./ImageWithTag";

function Block2() {
  return (
    <>
      <div className="flex flex-row md:px-5 pt-5">
        {/* Image */}
        <div className="w-4/12">
          <img src="https://demo.tagdiv.com/newspaper_pro/wp-content/uploads/2019/08/8-696x464.jpg" />
        </div>
        <div className="w-8/12 text-sm px-4 flex flex-col justify-between">
          <div className="font-medium text-black">
            Spring Fashion Show at the University of Michigan Has Started
          </div>
          <div className="text-gray-400 text-xs-s">August 7, 2019</div>
        </div>
      </div>
    </>
  );
}

export default Block2;
